import { defineMessages } from 'react-intl';

export default defineMessages({
    declarationPageContainerHeader: {
        id: 'tdic.endorsement.declaration-Page.Print My Declaration Page',
        defaultMessage: 'Print My Declaration Page'
    },
    declarationPagesCheckbox: {
        id: 'tdic.endorsement.declaration-Page.By clicking the signature box, I agree to the Terms of Use and confirm the information I have provided is true and accurate.',
        defaultMessage: 'By clicking the signature box, I agree to the Terms of Use and confirm the information I have provided is true and accurate.'
    },
    submit: {
        id: 'tdic.endorsement.declaration-Page.Submit',
        defaultMessage: 'Submit'
    },
    back: {
        id: 'tdic.endorsement.declaration-Page.Back',
        defaultMessage: 'Back'
    },
    backToHomepage: {
        id: 'tdic.endorsement.declaration-Page.Back to Homepage',
        defaultMessage: 'Back to Homepage'
    },
    infoMsgDeclarationPage: {
        id: 'tdic.endorsement.declaration-Page.Your current declaration page has been generated successfully. Please click the link below to view/download.',
        defaultMessage: 'Your current declaration page has been generated successfully. Please click the link below to view/download.'
    },
    changeSubmitted: {
        id: 'tdic.endorsement.declaration-Page.Change Submitted',
        defaultMessage: 'Change Submitted'
    },
    pageFailure: {
        id: 'tdic.endorsement.declaration-Page.failure',
        defaultMessage: 'Sorry, we were not able to print declaration page of your policy.'
    },
    loaderText: {
        id: 'tdic.endorsement.declaration-Page.Just a moment. We are preparing your documents.',
        defaultMessage: 'Just a moment. We are preparing your documents.'
    }
});
